'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _uuid = require('uuid');

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _forEach = require('lodash/forEach');

var _forEach2 = _interopRequireDefault(_forEach);

var _pick3 = require('lodash/pick');

var _pick4 = _interopRequireDefault(_pick3);

var _applicationState = require('../../../../utils/applicationState');

var _prerollUtils = require('../../../../utils/prerollUtils');

var _prerollUtils2 = _interopRequireDefault(_prerollUtils);

var _constants = require('../../../../utils/constants');

var _constants2 = _interopRequireDefault(_constants);

var _htmlUtils = require('../../../../utils/htmlUtils');

var _isDebugEnabled = require('../../../../utils/isDebugEnabled');

var _isDebugEnabled2 = _interopRequireDefault(_isDebugEnabled);

var _reporter = require('../../../../ads/reporter');

var _reporter2 = _interopRequireDefault(_reporter);

var _adSlotManager = require('../../../../ads/adSlotManager');

var _adSlotManager2 = _interopRequireDefault(_adSlotManager);

var _logger = require('../../../../logging/logger');

var _logger2 = _interopRequireDefault(_logger);

var _constants3 = require('../../../../logging/constants');

var _imaEvents = require('./imaEvents');

var _imaEvents2 = _interopRequireDefault(_imaEvents);

var _ImaPlayer = require('./ImaPlayer');

var _ImaPlayer2 = _interopRequireDefault(_ImaPlayer);

var _CompanionAdManager = require('../../companions/CompanionAdManager');

var _CompanionAdManager2 = _interopRequireDefault(_CompanionAdManager);

var _CompanionCache = require('../../companions/CompanionCache');

var _CompanionCache2 = _interopRequireDefault(_CompanionCache);

var _companionEvents = require('../../companions/companionEvents');

var _companionEvents2 = _interopRequireDefault(_companionEvents);

var _Events = require('../../Events');

var _Events2 = _interopRequireDefault(_Events);

var _mediaEvents = require('../../mediaEvents');

var _mediaEvents2 = _interopRequireDefault(_mediaEvents);

var _constants4 = require('../../../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var imaPlayerAdapter = {
  adSlot: {},
  imaPlayer: null,
  companionAdManager: null,
  init: function init() {
    _logger2.default.debugEnabled = (0, _isDebugEnabled2.default)();

    this.volume = this._volume.bind(this);

    this.onAdRequested = this._onAdRequested.bind(this);
    this.onAdLoaded = this._onAdLoaded.bind(this);
    this.onAdStarted = this._onAdStarted.bind(this);
    this.onAdImpression = this._onAdImpression.bind(this);
    this.onAdCompleted = this._onAdCompleted.bind(this);
    this.onAdCompanionLoadError = this._onAdCompanionLoadError.bind(this);
    this.onAdError = this._onAdError.bind(this);
    this.onAutoPlayError = this._onAutoPlayError.bind(this);

    this.onVideoAdLoaded = this._onVideoAdLoaded.bind(this);
    this.onVideoAdStarted = this._onVideoAdStarted.bind(this);
    this.onVideoAdVolumeChanged = this._onVideoAdVolumeChanged.bind(this);
    this.onVideoAdImpression = this._onVideoAdImpression.bind(this);
    this.onVideoAdPaused = this._onVideoAdPaused.bind(this);
    this.onVideoAdProgress = this._onVideoAdProgress.bind(this);
    this.onVideoAdResumed = this._onVideoAdResumed.bind(this);
    this.onVideoAdCompleted = this._onVideoAdCompleted.bind(this);

    this.onAudioLoaded = this._onAudioLoaded.bind(this);
    this.onAudioAdStarted = this._onAudioAdStarted.bind(this);
    this.onAudioAdPaused = this._onAudioAdPaused.bind(this);
    this.onAudioAdProgress = this._onAudioAdProgress.bind(this);
    this.onAudioAdResumed = this._onAudioAdResumed.bind(this);
    this.onAudioAdCompleted = this._onAudioAdCompleted.bind(this);
    this.onAudioCompanionsLoaded = this._onAudioCompanionsLoaded.bind(this);

    this.onAudioCompanion = this._onAudioCompanion.bind(this);
    this.onInvalidCompanionClickHandler = this._onInvalidCompanionClickHandler.bind(this);
    this.onCompanionAdRenderError = this._onCompanionAdRenderError.bind(this);
    this.onCompanionAdClick = this._onCompanionAdClick.bind(this);
    this.onCompanionSlotRefresh = this._onCompanionSlotRefresh.bind(this);
  },
  registerEventHandlers: function registerEventHandlers() {
    this.imaPlayer.on(_imaEvents2.default.AdEvent.AD_REQUESTED, this.onAdRequested);
    this.imaPlayer.on(_imaEvents2.default.AdEvent.AD_LOADED, this.onAdLoaded);
    this.imaPlayer.on(_imaEvents2.default.AdEvent.AD_STARTED, this.onAdStarted);
    this.imaPlayer.on(_imaEvents2.default.AdEvent.AD_IMPRESSION, this.onAdImpression);
    this.imaPlayer.on(_imaEvents2.default.AdEvent.AD_COMPLETED, this.onAdCompleted);
    this.imaPlayer.on(_imaEvents2.default.AdEvent.AD_COMPANIONS_LOAD_ERROR, this.onAdCompanionLoadError);
    this.imaPlayer.on(_imaEvents2.default.AdEvent.AD_ERROR, this.onAdError);
    this.imaPlayer.on(_imaEvents2.default.AdEvent.AUTOPLAY_DISALLOWED_ERROR, this.onAutoPlayError);

    this.imaPlayer.on(_imaEvents2.default.VideoEvent.AD_LOADED, this.onVideoAdLoaded);
    this.imaPlayer.on(_imaEvents2.default.VideoEvent.AD_STARTED, this.onVideoAdStarted);
    this.imaPlayer.on(_imaEvents2.default.VideoEvent.AD_VOLUME_CHANGED, this.onVideoAdVolumeChanged);
    this.imaPlayer.on(_imaEvents2.default.VideoEvent.AD_IMPRESSION, this.onVideoAdImpression);
    this.imaPlayer.on(_imaEvents2.default.VideoEvent.AD_PAUSED, this.onVideoAdPaused);
    this.imaPlayer.on(_imaEvents2.default.VideoEvent.AD_PROGRESS, this.onVideoAdProgress);
    this.imaPlayer.on(_imaEvents2.default.VideoEvent.AD_RESUMED, this.onVideoAdResumed);
    this.imaPlayer.on(_imaEvents2.default.VideoEvent.AD_COMPLETED, this.onVideoAdCompleted);

    this.imaPlayer.on(_imaEvents2.default.AudioEvent.AD_LOADED, this.onAudioLoaded);
    this.imaPlayer.on(_imaEvents2.default.AudioEvent.AD_STARTED, this.onAudioAdStarted);
    this.imaPlayer.on(_imaEvents2.default.AudioEvent.AD_PAUSED, this.onAudioAdPaused);
    this.imaPlayer.on(_imaEvents2.default.AudioEvent.AD_PROGRESS, this.onAudioAdProgress);
    this.imaPlayer.on(_imaEvents2.default.AudioEvent.AD_RESUMED, this.onAudioAdResumed);
    this.imaPlayer.on(_imaEvents2.default.AudioEvent.AD_COMPLETED, this.onAudioAdCompleted);
    this.imaPlayer.on(_imaEvents2.default.AudioEvent.AD_COMPANIONS_LOADED, this.onAudioCompanionsLoaded);

    this.companionAdManager.on(_companionEvents2.default.loaded, this.onAudioCompanion);
    this.companionAdManager.on(_companionEvents2.default.clickError, this.onInvalidCompanionClickHandler);
    this.companionAdManager.on(_companionEvents2.default.renderError, this.onCompanionAdRenderError);
    this.companionAdManager.on(_companionEvents2.default.clicked, this.onCompanionAdClick);
    this.companionAdManager.on(_companionEvents2.default.refreshDisplaySlot, this.onCompanionSlotRefresh);
    _logger2.default.debug('Registered All IMA Preroll Events.');
  },
  removeEventHandlers: function removeEventHandlers() {
    this.imaPlayer.off(_imaEvents2.default.AdEvent.AD_REQUESTED);
    this.imaPlayer.off(_imaEvents2.default.AdEvent.AD_LOADED);
    this.imaPlayer.off(_imaEvents2.default.AdEvent.AD_STARTED);
    this.imaPlayer.off(_imaEvents2.default.AdEvent.AD_IMPRESSION);
    this.imaPlayer.off(_imaEvents2.default.AdEvent.AD_COMPLETED);
    this.imaPlayer.off(_imaEvents2.default.AdEvent.AD_COMPANIONS_LOAD_ERROR);
    this.imaPlayer.off(_imaEvents2.default.AdEvent.AD_ERROR);

    this.imaPlayer.off(_imaEvents2.default.VideoEvent.AD_LOADED);
    this.imaPlayer.off(_imaEvents2.default.VideoEvent.AD_STARTED);
    this.imaPlayer.off(_imaEvents2.default.VideoEvent.AD_VOLUME_CHANGED);
    this.imaPlayer.off(_imaEvents2.default.VideoEvent.AD_IMPRESSION);
    this.imaPlayer.off(_imaEvents2.default.VideoEvent.AD_PAUSED);
    this.imaPlayer.off(_imaEvents2.default.VideoEvent.AD_PROGRESS);
    this.imaPlayer.off(_imaEvents2.default.VideoEvent.AD_RESUMED);
    this.imaPlayer.off(_imaEvents2.default.VideoEvent.AD_COMPLETED);

    this.imaPlayer.off(_imaEvents2.default.AudioEvent.AD_LOADED);
    this.imaPlayer.off(_imaEvents2.default.AudioEvent.AD_STARTED);
    this.imaPlayer.off(_imaEvents2.default.AudioEvent.AD_PAUSED);
    this.imaPlayer.off(_imaEvents2.default.AudioEvent.AD_PROGRESS);
    this.imaPlayer.off(_imaEvents2.default.AudioEvent.AD_RESUMED);
    this.imaPlayer.off(_imaEvents2.default.AudioEvent.AD_COMPLETED);
    this.imaPlayer.off(_imaEvents2.default.AudioEvent.AD_COMPANIONS_LOADED);

    this.companionAdManager.off(_companionEvents2.default.loaded);
    this.companionAdManager.off(_companionEvents2.default.clickError);
    this.companionAdManager.off(_companionEvents2.default.renderError);
    this.companionAdManager.off(_companionEvents2.default.clicked);
    this.companionAdManager.off(_companionEvents2.default.refreshDisplaySlot);
    _logger2.default.debug('Removed All IMA Preroll Events.');
  },
  resetAdSlots: function resetAdSlots() {
    var companions = _adSlotManager2.default.getCompanionSlots();
    if (companions.length) {
      (0, _forEach2.default)(companions, function (slot) {
        return slot.refresh();
      });
      _adSlotManager2.default.resetCompanionSlots();
    } else {
      (0, _forEach2.default)(_adSlotManager2.default.getDisplaySlots(), function (slot) {
        return slot.refresh();
      });
    }
  },
  addPlayerScript: function addPlayerScript() {
    if (global.google) {
      return Promise.resolve();
    }

    return new Promise(function (res, rej) {
      (0, _htmlUtils.addScript)(_constants4.IMA_PLAYER_SCRIPT, true, _constants4.IMA_PLAYER_SCRIPT_ID, function (e) {
        if (e.type === _constants4.IMA_SCRIPT_LOAD_EVENT_TYPE) {
          res();
        } else {
          rej();
        }
      });
    });
  },


  /**
   * A part of the Mint playerAdapter interface that is common among the two preroll media players.
   * The registerSlot method is called to create and initialize the HTMLMediaElement that will be
   * used by the ImaPlayer, and Google's IMA Player SDK, to play ads.
   *
   * @param slot {MintSlot}: A model representing an HTMLElement where an ad can be inserted.
   */
  initializeAndRegisterSlot: function initializeAndRegisterSlot(slot) {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.addPlayerScript();

            case 2:
              try {
                _this.companionAdManager = new _CompanionAdManager2.default(new _CompanionCache2.default());
                _this.imaPlayer = new _ImaPlayer2.default(global.google);
                _this.imaPlayer.initialize(slot.name, {
                  volume: (0, _applicationState.getState)(_applicationState.State.volume),
                  isMobile: (0, _applicationState.getState)(_applicationState.State.isMobile)
                });
                (0, _applicationState.addStateChangeListener)('volume', _this.volume);
                _logger2.default.debug('Created New IMA Player. (initializeAndRegisterSlot)');
              } catch (ex) {
                _logger2.default.debug('Error during registeringSlot.', ex);
                _logger2.default.error({
                  message: _constants3.IMA_PLAYER_ERROR,
                  error: ex
                });
              }

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  isInitialized: function isInitialized() {
    return !!this.imaPlayer;
  },

  /**
   * A part of the Mint playerAdapter interface that is common among the two preroll media players.
   * The deregisterSlot method is called to destroy the currently set ImaPlayer instance. This stops
   * current ad playback, unloads and destroy the underlying IMA SDK ad modules, and removes the
   * HTMLMedia element, that was created by calling registerSlot, from the DOM.
   *
   * @param slot {MintSlot}: A model representing an HTMLElement where an ad can be inserted.
   */
  deregisterSlot: function deregisterSlot(slot) {
    if (!slot || !this.adSlot) {
      return;
    }
    var slotName = this.adSlot.name;
    if (slot.name !== slotName || slot.elementId !== slotName) {
      return;
    }
    (0, _applicationState.removeStateChangeListener)('volume', this.volume);
    this.imaPlayer.destroy();
    this.removeEventHandlers();
    _logger2.default.debug('Destroyed IMA Player. (deregisterSlot)');
  },


  /**
   * A part of the Mint playerAdapter interface that is common among the two preroll media players.
   * The serveAd method plays an ad through from beginning to end, or until an error occurs during
   * playback. The method is also responsible for registering the event handlers that are used to
   * update the upper level Mint state in response to state changes in the underlying ad media.
   *
   * After the ad has completed, or an error has occurred, the method unloads the ad from the
   * ImaPlayer which resets the player for the next time serveAd is called.
   *
   * @param params {{ slot, urlTag }}: Object containing the MintSlot, and ad request url for
   *  the player.
   * @returns {Promise<void>}
   */
  serveAd: function serveAd(params) {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var slot, urlTag;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              slot = params.slot, urlTag = params.urlTag;
              _context2.next = 4;
              return _this2.managePlayBack(slot, urlTag);

            case 4:
              _context2.next = 9;
              break;

            case 6:
              _context2.prev = 6;
              _context2.t0 = _context2['catch'](0);

              _logger2.default.error({
                message: _constants3.IMA_PLAYER_ERROR,
                error: _context2.t0,
                data: _reporter2.default.getParameters(_this2.adSlot)
              });

            case 9:
              _this2.adSlot = {};
              _this2.isPlayingVideo = false;

              _this2.resetAdSlots();
              _this2.removeEventHandlers();

              _this2.imaPlayer.unload();
              _logger2.default.debug('Finished Playing IMA Preroll Ad.');

            case 15:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[0, 6]]);
    }))();
  },
  managePlayBack: function managePlayBack(slot, url) {
    var _this3 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;

              if (!(!slot || !url)) {
                _context3.next = 4;
                break;
              }

              _logger2.default.error({
                message: _constants3.IMA_PLAYER_ERROR,
                error: new Error('No slot or urlTag provided to serveAd')
              });
              return _context3.abrupt('return');

            case 4:
              _this3.adSlot = slot;
              _this3.adSlot.medium = _constants2.default.MediumTypes.audio;
              _this3.adSlot.requestId = (0, _uuid.v4)();
              _this3.isPlayingVideo = false;
              _this3.registerEventHandlers();
              _context3.next = 11;
              return _this3.playAd(url);

            case 11:
              _context3.next = 16;
              break;

            case 13:
              _context3.prev = 13;
              _context3.t0 = _context3['catch'](0);

              _logger2.default.error({
                message: _constants3.IMA_PLAYER_ERROR,
                error: _context3.t0,
                data: _reporter2.default.getParameters(_this3.adSlot)
              });

            case 16:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3, [[0, 13]]);
    }))();
  },


  /**
   * Method to ensure that the ad either plays until completion, or until an error occurs.
   *
   * @param url {string}: ad request url
   * @returns {Promise<any>}
   */
  playAd: function playAd(url) {
    var _this4 = this;

    return new Promise(function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(resolve) {
        var handleException;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                handleException = function handleException(ex) {
                  _logger2.default.error({
                    message: _constants3.IMA_PLAYER_ERROR,
                    error: ex,
                    data: _reporter2.default.getParameters(_this4.adSlot)
                  });
                  resolve();
                };

                _context4.prev = 1;

                _this4.imaPlayer.once(_imaEvents2.default.AdEvent.AD_ERROR, handleException);
                _this4.imaPlayer.once(_imaEvents2.default.AdEvent.AUTOPLAY_DISALLOWED_ERROR, handleException);
                _this4.imaPlayer.once(_imaEvents2.default.AdEvent.AD_COMPLETED, resolve);
                _context4.next = 7;
                return _this4.imaPlayer.start(url);

              case 7:
                _context4.next = 12;
                break;

              case 9:
                _context4.prev = 9;
                _context4.t0 = _context4['catch'](1);

                handleException(_context4.t0);

              case 12:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[1, 9]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
  },
  preload: function preload(slot) {
    var _this5 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              if (_this5.isInitialized()) {
                _context5.next = 3;
                break;
              }

              _context5.next = 3;
              return _this5.initializeAndRegisterSlot(slot);

            case 3:
              _this5.imaPlayer.preload();

            case 4:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },


  /**
   * Media methods that are exposed so that underlying ad media can be manipulated. Some
   * of these methods are only available if the currently loaded ad is a video ad, otherwise
   * they are noop.
   */

  /**
   * The IMA SDK only exposes a start and a resume method. Mint doesn't expose functionality to
   * manually start an ad, unless it's initiated through the serveAd method above. Additionally,
   * the only real control a user has over resuming media playback is in the case of a video
   * ad where the user has previously paused it.
   */
  play: function play() {
    this.imaPlayer.resume();
  },
  pause: function pause() {
    this.imaPlayer.pause();
  },
  stop: function stop() {
    if (this.imaPlayer) {
      this.imaPlayer.stop();
    }
  },
  resize: function resize(width, height) {
    if (this.isPlayingVideo) {
      this.imaPlayer.resize(width, height);
    }
  },
  _volume: function _volume(volume) {
    this.imaPlayer.volume(volume);
  },


  /**
   * Generic AdEvent handlers that are responsible for performing actions and Mint state
   * updates that are not contingent on the contentType of the ad. These generic AdEvent
   * handlers are called after video/audio ones.
   */

  _onAdRequested: function _onAdRequested() {
    _reporter2.default.request(this.adSlot);
    _logger2.default.debug('Ad Requested.');
  },
  _onAdLoaded: function _onAdLoaded(ad) {
    var _pick = (0, _pick4.default)(ad, ['height', 'width', 'adId', 'creativeId']),
        height = _pick.height,
        width = _pick.width,
        adId = _pick.adId,
        creativeId = _pick.creativeId;

    (0, _applicationState.updateState)(_applicationState.State.prerollAdId, adId);
    (0, _applicationState.updateState)(_applicationState.State.prerollCreativeId, creativeId);

    var Type = _Events2.default.Type,
        Status = _Events2.default.Status;

    _mediaEvents2.default.event(Type.preroll, Status.loaded).emit({ height: height, width: width });
    _logger2.default.debug('Ad Loaded.');
  },
  _onAdStarted: function _onAdStarted() {
    (0, _applicationState.updateState)(_applicationState.State.isFirstInSession, false);
    _prerollUtils2.default.setLastPrerollDate(Date.now());
    _reporter2.default.start(this.adSlot);
    _logger2.default.debug('Ad Started.');
  },
  _onAdImpression: function _onAdImpression() {
    _reporter2.default.impression(this.adSlot);
    _logger2.default.debug('Ad Impression.');
  },
  _onAdCompleted: function _onAdCompleted() {
    _reporter2.default.end(this.adSlot);
    _logger2.default.debug('Ad Completed.');
  },
  _onAdCompanionLoadError: function _onAdCompanionLoadError(error) {
    _logger2.default.error({
      message: _constants3.IMA_PLAYER_AD_COMPANION_ERROR,
      error: error,
      data: _reporter2.default.getParameters(this.adSlot)
    });
  },
  _onAdError: function _onAdError(error) {
    _reporter2.default.fail(this.adSlot, error);
    _logger2.default.error({
      message: _constants3.IMA_PLAYER_AD_ERROR,
      error: error,
      data: _reporter2.default.getParameters(this.adSlot)
    });
    this._emitPrerollError();
    _logger2.default.debug('Ad Error.', error);
  },
  _emitPrerollError: function _emitPrerollError() {
    var Type = _Events2.default.Type,
        Status = _Events2.default.Status;

    _mediaEvents2.default.event(Type.preroll, Status.error).emit();
  },
  _onAutoPlayError: function _onAutoPlayError(error) {
    _logger2.default.error({
      message: _constants3.IMA_PLAYER_AUTOPLAY_ERROR,
      error: error,
      data: _reporter2.default.getParameters(this.adSlot)
    });
    this._emitPrerollError();
  },


  /**
   * VideoAdEvent handlers that are responsible for performing actions and Mint state
   * updates that are specific to video ads only. These VideoAdEvent handlers are
   * called before the generic AdEvent handlers.
   */

  _onVideoAdLoaded: function _onVideoAdLoaded(ad) {
    this.isPlayingVideo = true;
    this.adSlot.medium = _constants2.default.MediumTypes.video;

    var volume = (0, _applicationState.getState)(_applicationState.State.volume);
    this.volume(volume);

    var clickThroughUrl = (0, _get2.default)(ad, 'clickThroughUrl');

    var Type = _Events2.default.Type,
        Media = _Events2.default.Media,
        Status = _Events2.default.Status;

    _mediaEvents2.default.event(Type.preroll, Media.video, Status.loaded).emit();
    _mediaEvents2.default.event(Type.preroll, Media.video, Status.volume).emit(volume);
    _mediaEvents2.default.event(Type.preroll, Media.video, Status.setLearnMore).emit(clickThroughUrl);
    _logger2.default.debug('Video Ad Loaded.');
  },
  _onVideoAdStarted: function _onVideoAdStarted() {
    (0, _applicationState.updateState)(_applicationState.State.isPlayingVideoPreroll, true);
    (0, _forEach2.default)(_adSlotManager2.default.getDisplaySlots(), function (slot) {
      return slot.refresh();
    });
    _mediaEvents2.default.event(_Events2.default.Type.preroll, _Events2.default.Media.video, _Events2.default.Status.playing).emit();
    _logger2.default.debug('Video Ad Started.');
  },
  _onVideoAdVolumeChanged: function _onVideoAdVolumeChanged(volume) {
    var playerVolume = volume <= 1 ? volume * 100 : volume;
    _mediaEvents2.default.event(_Events2.default.Type.preroll, _Events2.default.Media.video, _Events2.default.Status.volume).emit(playerVolume);
  },
  _onVideoAdImpression: function _onVideoAdImpression() {
    (0, _applicationState.updateState)(_applicationState.State.videoPrerollPlayed, true);
    _logger2.default.debug('Video Ad Impression.');
  },
  _onVideoAdPaused: function _onVideoAdPaused() {
    _mediaEvents2.default.event(_Events2.default.Type.preroll, _Events2.default.Media.video, _Events2.default.Status.paused).emit();
    _logger2.default.debug('Video Ad Paused.');
  },
  _onVideoAdProgress: function _onVideoAdProgress(event) {
    var Type = _Events2.default.Type,
        Media = _Events2.default.Media,
        Status = _Events2.default.Status;

    _mediaEvents2.default.event(Type.preroll, Media.video, Status.progress).emit(event);
    _logger2.default.debug('Video Ad Progress.');
  },
  _onVideoAdResumed: function _onVideoAdResumed() {
    _mediaEvents2.default.event(_Events2.default.Type.preroll, _Events2.default.Media.video, _Events2.default.Status.playing).emit();
    _logger2.default.debug('Video Ad Resumed.');
  },
  _onVideoAdCompleted: function _onVideoAdCompleted() {
    (0, _applicationState.updateState)(_applicationState.State.isPlayingVideoPreroll, false);
    _mediaEvents2.default.event(_Events2.default.Type.preroll, _Events2.default.Media.video, _Events2.default.Status.ended).emit();
    _logger2.default.debug('Video Ad Completed.');
  },


  /**
   * AudioAdEvent handlers that are responsible for performing actions and Mint state
   * updates that are specific to audio ads only. These AudioAdEvent handlers are
   * called before the generic AdEvent handlers.
   */

  _onAudioLoaded: function _onAudioLoaded() {
    this.isPlayingVideo = false;
    this.adSlot.medium = _constants2.default.MediumTypes.audio;
    _mediaEvents2.default.event(_Events2.default.Type.preroll, _Events2.default.Media.audio, _Events2.default.Status.loaded).emit();
    _logger2.default.debug('Audio Ad Loaded.');
  },
  _onAudioAdStarted: function _onAudioAdStarted() {
    _mediaEvents2.default.event(_Events2.default.Type.preroll, _Events2.default.Media.audio, _Events2.default.Status.playing).emit();
    _logger2.default.debug('Audio Ad Started.');
  },
  _onAudioAdPaused: function _onAudioAdPaused() {
    _mediaEvents2.default.event(_Events2.default.Type.preroll, _Events2.default.Media.audio, _Events2.default.Status.paused).emit();
    _logger2.default.debug('Audio Ad Paused.');
  },
  _onAudioAdProgress: function _onAudioAdProgress(event) {
    var Type = _Events2.default.Type,
        Media = _Events2.default.Media,
        Status = _Events2.default.Status;

    _mediaEvents2.default.event(Type.preroll, Media.audio, Status.progress).emit(event);
    _logger2.default.debug('Audio Ad Progress.');
  },
  _onAudioAdResumed: function _onAudioAdResumed() {
    _mediaEvents2.default.event(_Events2.default.Type.preroll, _Events2.default.Media.audio, _Events2.default.Status.playing).emit();
    _logger2.default.debug('Audio Ad Resumed.');
  },
  _onAudioAdCompleted: function _onAudioAdCompleted() {
    _mediaEvents2.default.event(_Events2.default.Type.preroll, _Events2.default.Media.audio, _Events2.default.Status.ended).emit();
    _logger2.default.debug('Audio Ad Completed.');
  },
  _onAudioCompanionsLoaded: function _onAudioCompanionsLoaded(companions) {
    try {
      var displaySlots = _adSlotManager2.default.getDisplaySlots();
      var adProvider = (0, _get2.default)(this.adSlot, 'formatDefinition.adProvider');
      if (!adProvider) {
        return;
      }
      _logger2.default.debug('Audio Ad Companions Loaded.');
      this.companionAdManager.processCompanionAds(companions, displaySlots, adProvider);
    } catch (ex) {
      _logger2.default.error({
        message: _constants3.IMA_PLAYER_AD_COMPANION_ERROR,
        error: ex,
        data: _reporter2.default.getParameters(this.adSlot)
      });
    }
  },


  /**
   * CompanionAdEvent handlers that are responsible for performing actions and Mint state
   * updates that are specific to companion ads.
   */

  _onCompanionSlotRefresh: function _onCompanionSlotRefresh(slotId) {
    var displaySlot = _adSlotManager2.default.getSlot(slotId);
    if (displaySlot) {
      displaySlot.refresh();
    }
  },
  _onAudioCompanion: function _onAudioCompanion(companionSlot) {
    try {
      var elementId = companionSlot.elementId,
          name = companionSlot.name,
          format = companionSlot.format,
          width = companionSlot.width,
          height = companionSlot.height,
          content = companionSlot.content;

      if (!elementId || !name || !format || !width || !height || !content) {
        return;
      }

      var mintSlot = _adSlotManager2.default.getSlot(elementId);
      if (!mintSlot) {
        return;
      }

      if (mintSlot.adTypeController) {
        mintSlot.adTypeController.deregisterSlot(mintSlot);
        mintSlot.adTypeController.releaseSlot(mintSlot);
      }

      mintSlot.formatDefinition = format;
      mintSlot.currentDimensions = [width, height];
      mintSlot.requestId = this.adSlot.requestId;

      var slotElement = global.document.getElementById(elementId);
      if (!slotElement) {
        return;
      }

      this.companionAdManager.renderCompanionAd(slotElement, mintSlot, width, height, content);
      _adSlotManager2.default.addCompanionSlot(mintSlot);
      _reporter2.default.impression(mintSlot);
      _logger2.default.debug('Audio Ad Companion Rendered/Impression.');
    } catch (ex) {
      _logger2.default.error({
        message: _constants3.IMA_PLAYER_AD_COMPANION_ERROR,
        error: ex,
        data: _reporter2.default.getParameters(this.adSlot)
      });
    }
  },
  _onCompanionAdClick: function _onCompanionAdClick(slot) {
    if (!slot) {
      return;
    }
    _reporter2.default.click(slot);
    _logger2.default.info({ message: _constants3.COMPANION_AD_CLICKED, data: _reporter2.default.getParameters(slot) });
  },
  _onInvalidCompanionClickHandler: function _onInvalidCompanionClickHandler(slot) {
    if (!slot) {
      return;
    }
    _logger2.default.error({ message: _constants3.COMPANION_INVALID_CLICK_HANDLER, data: _reporter2.default.getParameters(slot) });
  },
  _onCompanionAdRenderError: function _onCompanionAdRenderError(event) {
    var _pick2 = (0, _pick4.default)(event, ['slot', 'error']),
        slot = _pick2.slot,
        error = _pick2.error;

    if (!slot || !error) {
      return;
    }
    _logger2.default.error({ message: _constants3.COMPANION_AD_RENDER_ERROR, error: error, data: _reporter2.default.getParameters(slot) });
  }
};

exports.default = imaPlayerAdapter;